import { Injectable, OnDestroy } from '@angular/core';
import {
  CalcField,
  DocumentQueryPagination,
  DocumentQueryParams,
  FilterGroup,
  FilterGroupType,
  RuleOperator
} from '../../core/store/models';
import { ListQuery, QueryParamsWithDocuments } from '../store/lists/models/card.model';

@Injectable({
  providedIn: 'root'
})
export class ListDataService {
  public getQuery(
    listQuery: ListQuery,
    layerUId: string,
    sort?: string,
    skip?: number,
    take?: number,
    fields?: string,
    calcFields?: CalcField[],
    extraFilter?: FilterGroup,
    columnFilter?: FilterGroup,
    groupFilter?: FilterGroup
  ): DocumentQueryParams {
    let layerQuery = {} as DocumentQueryParams;

    if (!!!listQuery.data?.layerQueries[layerUId]) {
      return layerQuery;
    }

    if (listQuery.data?.type === 'cluster' && listQuery.data?.layerQueries[layerUId].documents?.length > 0) {
      const filterGroup = {
        groupType: FilterGroupType.And,
        filters: [
          {
            field: 'uid',
            operator: RuleOperator.In,
            value: listQuery.data?.layerQueries[layerUId].documents?.join(',')
          }
        ]
      };
      const pagination: DocumentQueryPagination = {
        skip: skip || 0,
        take: take || listQuery.data?.layerQueries[layerUId].documents.length
      };
      layerQuery = {
        filterGroup,
        pagination,
        fields: fields,
        calcFields: calcFields,
        sort: sort || 'date_created desc'
      } as DocumentQueryParams;
    } else {
      layerQuery = {
        filterGroup: listQuery.data?.layerQueries[layerUId].query.filterGroup,
        pagination: {
          skip: skip || listQuery.data?.layerQueries[layerUId].query.pagination?.skip,
          take: take || listQuery.data?.layerQueries[layerUId].query.pagination?.take
        },
        fields: fields,
        calcFields: calcFields,
        sort: sort || listQuery.data?.layerQueries[layerUId].query.sort
      } as DocumentQueryParams;
    }

    if (!!extraFilter || !!columnFilter || !!groupFilter) {
      const combinedFilterGroup: FilterGroup = {
        groupType: FilterGroupType.And,
        filters: [],
        filterGroups: []
      };
      if (!!layerQuery.filterGroup) {
        combinedFilterGroup.filterGroups.push(layerQuery.filterGroup);
      }
      if (!!!groupFilter && !!extraFilter) {
        combinedFilterGroup.filterGroups.push(extraFilter);
      }
      if (!!!groupFilter && !!columnFilter) {
        combinedFilterGroup.filterGroups.push(columnFilter);
      }
      if (!!groupFilter) {
        combinedFilterGroup.filterGroups.push(groupFilter);
      }
      return {
        filterGroup: combinedFilterGroup,
        pagination: layerQuery.pagination,
        fields: layerQuery.fields,
        calcFields: layerQuery.calcFields,
        sort: layerQuery.sort
      };
    }

    return layerQuery;
  }
}
